import { render } from "./assessment-panel--history.vue?vue&type=template&id=47faa496&scoped=true&ts=true"
import script from "./assessment-panel--history.vue?vue&type=script&lang=ts"
export * from "./assessment-panel--history.vue?vue&type=script&lang=ts"

import "./assessment-panel--history.vue?vue&type=style&index=0&id=47faa496&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47faa496"]])

export default __exports__